export const firebaseVzlaConfig = {
  apiKey: 'AIzaSyD5yHdSXZW_rNw39I2m5FIX4Ym40xWJepY',
  authDomain: 'oracle-services-vzla.firebaseapp.com',
  databaseURL: 'https://oracle-services-vzla.firebaseio.com',
  projectId: 'oracle-services-vzla',
  storageBucket: 'oracle-services-vzla.appspot.com',
  messagingSenderId: '1071850495527',
  appId: '1:1071850495527:web:149c8892beb9d9810f7802'
};
